<!-- ========================== Footer (Start) ========================== -->
<footer class="l-footer">
  <ul style="display: flex; align-items: center" class="footer-menu">
    <mat-menu #aboveMenu="matMenu" yPosition="above"> </mat-menu>
    <div style="display: flex; align-items: center">
      <!-- <li (click)="(false)" class="footer-menu-item">
        <button (click)="goMedical()" class="footer-menu-link" style="font-weight: bolder; color: #015a6c">
          {{'appointments.gui.buttons.Medical' | translate}}
        </button>
      </li>
      <li *ngIf="loginService.premissions?.Appointments" class="footer-menu-item">
        <button [disabled]="currentRoute === 'appointments'" (click)="goAppointments()" class="footer-menu-link"
          style="font-weight: bolder; color: #015a6c">
          {{'appointments.gui.buttons.Appointments' | translate}}
        </button>
      </li>
      <li *ngIf="loginService.premissions?.Billings" class="footer-menu-item">
        <button [disabled]="currentRoute === 'billing'" (click)="goBilling()" class="footer-menu-link"
          style="font-weight: bolder; color: #015a6c">
          {{'appointments.gui.buttons.Billing' | translate}}
        </button>
      </li>
      <hr style="
          height: 2em;
          transform: rotate(180deg);
          margin-right: 1em;
          border-radius: 100%;
          opacity: 0.5;
        " /> -->
      <li class="footer-menu-item">
        <button class="footer-menu-link support-center-link" (click)="goTrainingHub()">
          {{'appointments.gui.buttons.Support Center' | translate}}
        </button>
      </li>

      <li class="footer-menu-item">
        <a class="footer-menu-link" routerLink="/privacy-policy"> Privacy Policy </a>
      </li>

      <li class="footer-menu-item">
        <button class="footer-menu-link">
          {{'appointments.gui.buttons.Terms of Use' | translate}}
        </button>
      </li>
    </div>
  </ul>

  <div class="footer-credit">© 2006-{{ currentYear }} Artisan Sonics, Inc</div>
</footer>
<!-- ========================== Footer (End) ========================== -->